var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"build views",style:(_vm.viewStyle)},[(_vm.showBtn)?_c('div',{staticClass:"fullscreenBtn"},[_c('i',{staticClass:"el-icon-full-screen icon",on:{"click":_vm.fullscreenToggel}})]):_vm._e(),_c('container',{ref:"container",attrs:{"id":_vm.id,"target":_vm.target,"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }